<div class="fullscreen">
    <div class="row justify-content-center m-0 auth-box">
        <div class="col-sm-6 p-0">

            <form #loginForm="ngForm" (ngSubmit)="login()">
            <mat-card class="p-0">
                <div class="primary-bg flex-display">
                    <button mat-icon-button class="m-auto" (click)="navigateToRoute(routes.AUTH)">
                        <mat-icon class="white">arrow_back</mat-icon>
                    </button>
                    <h3 translate class="align-text-center auth-header">SIGNIN.LOGIN_TITLE</h3>
                </div>

                <!-- Email address-->
                <mat-card-content class="p-4">
                    <mat-form-field class="w-100">
                        <mat-icon matPrefix class="mr-2">email</mat-icon>
                        <input matInput #email="ngModel" type="text" name="username" placeholder="{{'SIGNIN.EMAIL' | translate }}" [(ngModel)]="username" required readonly>
                    </mat-form-field>

                    <!-- Password-->
                    <mat-form-field class="w-100">
                        <mat-icon matPrefix class="mr-2">lock</mat-icon>
                        <input matInput #pass="ngModel" type="password" name="password" placeholder="{{'SIGNIN.PASS' | translate }}" [(ngModel)]="password" required >
                        <mat-hint>{{ 'SIGNIN.PASSWORD_LENGTH' | translate }}</mat-hint>
                    </mat-form-field>
                </mat-card-content>
                
                <mat-card-actions class="m-0 p-4">
                    <button mat-raised-button color="primary" type="submit" class="w-100 m-0" [disabled]="email.invalid || pass.invalid">{{ 'GENERIC.LOGIN' | translate }}</button>
                    <button mat-button color="primary" type="button" (click)="openForgotDialog()" class="w-100 m-0 mt-2">{{ 'SIGNIN.FORGOT' | translate }}</button>
                </mat-card-actions>
            </mat-card>
            </form>
        </div>
    </div>

</div>
<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>